import * as React from 'react'
import { Select } from '@doordash/component-fields'
import { arrayToOptions } from '../../../utilities/vehicle'

export const SelectComponent = ({ ...props }) => {
  const optionsFromTemplate = props.data_map || arrayToOptions(props.data)
  const options = props.placeholder
    ? [
      {
        name: props.placeholder,
        value: '',
      },
      ...optionsFromTemplate,
    ]
    : optionsFromTemplate

  return <Select options={options} {...props} />
}
